import type { AxiosPromise } from 'axios';
import BaseClient from './BaseClient';
import type { ActiveTermResponse, TermsClientInterface } from './termsClient.types';

class TermsClient extends BaseClient implements TermsClientInterface {
    getActiveTerm(teamId: number, groupId: string): AxiosPromise<ActiveTermResponse> {
        const url = `/api/v3/teams/${teamId}/groups/${groupId}/terms/active`;
        return this.makeCoreApiRequest(url, 'get');
    }

    acceptTerm(teamId: number, groupId: string, termId: number): AxiosPromise<void> {
        const url = `/api/v3/teams/${teamId}/groups/${groupId}/terms/${termId}/accept`;
        return this.makeCoreApiRequest(url, 'post');
    }
}

export default new TermsClient();
